import React from 'react'
import classNames from 'classnames'

import './Callout.css'

const Callout = ({ ...props }) => (
  <div className={classNames('c-callout', props.className)}>
    {props.message}
  </div>
)

export default Callout
